import React, { useState, useEffect } from 'react';
import './Case.scss';

const Case = ({ setProductPosition }) => {
  const [target, setTarget] = useState(null);

  const onIntersect = async ([entry], observer) => {
    if (entry.isIntersecting) {
      observer.unobserve(entry.target);
      setProductPosition(target.id);

      observer.observe(entry.target);
    }
  };

  useEffect(() => {
    let observer;
    if (target) {
      observer = new IntersectionObserver(onIntersect, { threshold: 0.5 });
      observer.observe(target);
    }
    return () => observer && observer.disconnect();
  });

  return (
    <div id="Case" className="case" ref={setTarget}>
      <div className="caseContentsLeft">
        <div className="caseContentsLeftTitle">
          아이스박스로 활용 가능한 친환경 EPP 소재 케이스
        </div>
        {/* <div className="caseContentsLeftSlogan">TUF Main Slogan</div> */}
        <div className="caseContentsLeftInfo">
          친환경 소재인 EPP (발포 폴리프로필렌) 소재의 
          <br />
          하드 케이스가 기본 제공됩니다,
          <br />
          캠핑 시 발생할 수 있는 외부 충격으로부터 
          <br />
          완전하게 TUF를 보호합니다.
        </div>
        {/* <div className="caseImgBox">
          <img className="caseImg" src="/images/Case1.jpg" alt="CaseIMG" />
          <img className="caseImg" src="/images/Case2.jpg" alt="CaseIMG" />
        </div> */}
      </div>
      <div className="caseContentsRight">
        <img
          className="caseContentsRightImage"
          alt="CaseIMG"
          src="/images/Case3WW.jpg"
        />
      </div>
    </div>
  );
};

export default Case;
